export default {
  "this field is required": "Campo obrigatório",
  "invalid CPF": "CPF inválido",
  "invalid CNPJ": "CNPJ inválido",
  "invalid email": "Email inválido",
  "invalid phone": "Telefone inválido",
  "invalid password": "Senha inválida",
  "invalid slug": "Slug inválido",
  "invalid url": "URL inválida",
  "select item": "Selecione um item",
  "size bigger": "Tamanho não suportado",
  "invalid type": "Tipo invalido",
  "invalid same": "Os campos precisam ser iguais"
};
